<template>
  <!-- <div class="about"> -->
    <!--右下角工具组件-->
    <div id="send"
         v-show="isSend"
         style="text-align: right">
      <svg t="1663665057037"
           class="icon close"
           @click="sendclickclose"
           style="cursor: pointer; padding: 6px"
           viewBox="0 0 1024 1024"
           version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           p-id="7039"
           width="32"
           height="32">
        <path d="M1022.293364 470.409918a511.990827 511.990827 0 1 0-551.883445 551.883446 513.484133 513.484133 0 0 0 551.883445-551.883446zM625.073814 549.768497l100.264871 100.05154A53.332378 53.332378 0 1 1 649.820038 725.338684l-100.051541-100.26487a53.759037 53.759037 0 0 0-75.518647 0L374.198309 725.338684A53.332378 53.332378 0 1 1 298.679662 649.820037l100.264871-100.05154a53.759037 53.759037 0 0 0 0-75.518647L298.679662 374.198309A53.332378 53.332378 0 0 1 374.198309 298.679662l100.051541 100.26487a53.759037 53.759037 0 0 0 75.518647 0l100.051541-100.26487A53.332378 53.332378 0 1 1 725.338685 374.198309l-100.264871 100.051541a53.759037 53.759037 0 0 0 0 75.518647z"
              fill="#D33737"
              p-id="7040"></path>
      </svg>

      <SendBox ref="child"></SendBox>
    </div>
    <div style="position: fixed; bottom: 50px; right: 0px; z-index: 99">
      <div class="demo">
        <div>
          <div class="row">
            <div class="col-md-12">
              <el-badge :value="unreadmsg"
                        :hidden="unreadmsg <= 0"
                        class="item"
                        type="danger">
                <div class="navbar">
                  <i class="iconfont icon-caidan iconsize"
                     style="color: #fff;"
                     @click="isbtn = !isbtn"></i>
                  <ul class="menu"
                      v-if="isbtn">
                    <li>
                      <a href="javascript:void(0)"
                         class="iconfont icon-jiqiren iconsize"
                         :style="{
                          color: clasclick == 1 ? 'rgb(9, 240, 240)' : '',
                        }"
                         @click="sendclick(1)"></a>
                    </li>
                    <li>
                      <span class="event-count"
                            v-show="unreadmsg > 0">{{
                        unreadmsg
                      }}</span>
                      <a href="javascript:void(0)"
                         class="iconfont icon-IMliaotian iconsize"
                         :style="{
                          color: clasclick == 0 ? 'rgb(9, 240, 240)' : '',
                        }"
                         @click="sendclick(0)"></a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                         class="icon iconfont icon-shujukanban"
                         @click="BtnMarketReport"></a>
                    </li>
                  </ul>
                </div>
              </el-badge>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--右下角工具组件-->
    <!-- <v-header />
    <v-sidebar />
    <div class="content-box"
         :class="{ 'content-collapse': collapse }">
      <v-tags></v-tags>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <el-dialog v-model="MarketReport"
               v-if="MarketReport"
               :close-on-click-modal="false"
               :before-close="handleClose">
      <MarketReportCard></MarketReportCard>
    </el-dialog> -->
    <Main></Main>
  <!-- </div> -->
</template>
<script>
// import vHeader from "../components/Header";
import SendBox from "../views/Send/Send.vue";
// import vSidebar from "../components/Sidebar";
import Main from "./Main.vue";
import { ElLoading } from "element-plus";
import { mapState } from "vuex";
import { ElNotification } from "element-plus";
// import MarketReportCard from "../views/Card/DataAnalysisCard/MarketReportCard.vue";
import store from '../store/index'
//import vTags from "../components/Tags.vue";
export default {
  components: {
    // vHeader,
    // vSidebar,
    SendBox,
    // MarketReportCard
    //vTags,
    Main
  },
  data () {
    return {
      isSend: false,
      msgcount: 0,
      clasclick: 2,
      MarketReport: false,
      MarketsReport: false,
      chat: false,
      unreadmsg: 0,
      isbtn: false,
    };
  },
  mounted () {
    this.$refs.child.scrollToBottom();
    this.Global.msgload();
    let that = this;
    if (that.$store.state.user.commit == 1) {
      that.isloading();
    }
    // window.onload = () => {
    //   //alert('11111111')
    //   this.Global.msgload();
    //   let that = this;
    //   if (that.$store.state.user.commit == 1) {
    //     that.isloading();
    //   }
    //   return true;
    // };
  },
  computed: {
    ...mapState({
      commit: (state) => state.user.commit,
      depcomit: (state) => state.user.depcomit,
      round: (state) => state.user.round,
      msgList: (state) => state.user.msg,
      Operationmsg: (state) => state.user.Operationmsg,
      Operationmsgcount: (state) => state.user.Operationmsgcount,
    }),
    tagsList () {
      return this.$store.state.tagsList.map((item) => item.name);
    },
    collapse () {
      return this.$store.state.collapse;
    },
  },
  watch: {
    commit (val) {
      if (val == 1) this.isloading();
    },
    round (val) {
      console.log(val);
      // alert("222222222");
      // alert(this.$store.state.user.round)
      //  alert(val);
    },
    depcomit (value) {
      if (value == 1) this.commitmd();
    },
    msgList: {
      handler (nval) {
        this.msgcount = parseInt(localStorage.getItem("msgcount"));
        if (this.msgcount == 0) {
          this.msgcount = nval.length;
          if (!this.isSend) {
            this.unreadmsg = this.msgcount;
          }
        }
        if (!this.isSend) {
          this.unreadmsg = nval.length - this.msgcount + this.unreadmsg;
        }
        this.msgcount = nval.length;
        localStorage.setItem("msgcount", this.msgcount);
      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
    Operationmsgcount: {
      handler (val) {
        if (val > 0) {
          ElNotification({
            title: "通知",
            message: this.Operationmsg,
            type: "info",
            customClass: "notifyStyle", //自定义类名
          });
        }
      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
  },

  methods: {
    getExhibition () {
      this.$http
        .get(
          "User/GetMoney?groupId=" +
          this.Global.groupid +
          "&round=" +
          this.round
        )
        .then((res) => {
          if (res.success) {
            this.$store.commit("setMoney", res.dynamicObj);
          } else {
            return this.$message.warning(res.message);
          }
        });
    },
    BtnMarketReport () {
      this.MarketReport = true;
    },
    BtnMarketsReport () {
      this.MarketsReport = true;
    },
    sendclickclose () {
      this.isSend = false;
      if (!this.isSend) {
        this.clasclick = 2;
      }
    },
    sendclick (type) {
      this.clasclick = type;
      this.$refs.child.scrollToBottom();
      if (!(this.$refs.child.msgType != type && this.isSend)) {
        this.isSend = !this.isSend;
        this.$refs.child.msgType = "";
      }
      if (this.isSend) {
        this.$refs.child.msgType = type; //修改子组件data
        if (type == 0) this.unreadmsg = 0;
      }
      if (!this.isSend) {
        this.clasclick = 2;
      }
    },
    isloading () {
      let that = this;
      const loading = ElLoading.service({
        lock: true,
        text: "已提交正在运算，请等待(｀・ω・')",
        // background: "rgba(0, 0, 0, 0.7)",
      });
      const timer = setInterval(function () {
        that.$http
          .get(`Run/IsComit?IsComit`)
          .then((childre) => {
            if (childre.success) {
              if (childre.dynamicObj.isRun) {
                clearInterval(timer);
                that.$store.commit("coomitmd", 0);
                that.$store.commit("changedepcomit", 0);
                let nextround = childre.dynamicObj.nextRound;
                that.$store.commit("changeround", nextround);
                store.commit("GetTaskBar", !store.state.user.taskBar); 
                that.getExhibition();
                loading.close();
              }
            } else {
              return that.$message.warning(childre.message);
            }
          });
      }, 5000);
    },
    commitmd () {
      let that = this;
      if (that.$store.state.user.depcomit == 1) {
        that.$store.commit("coomitmd", 1);
        // 如果是最后一个回合则不提交
      }
    },
  },
};
</script>
<style scoped>
.h1 {
  position: fixed;
  bottom: 30px;
  right: 5px;
}
.demo {
  padding: 2em 0;
  transform: translate3d(0, 0, 0);
}
.navbar {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  text-align: center;
  font-size: 1.75em;
  font-weight: bold;
  color: #383838;
  transition: 0.24s 0.2s;
}
.navbar .menu {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  top: -95px;
  left: -75px;
  border: 50px solid transparent;
  cursor: default;
  border-radius: 50%;
  transform: scale(0);
  transition: transform 1.4s 0.07s;
  z-index: -1;
}
.navbar .menu {
  transition: transform 0.4s 0.08s, z-index 0s 0.5s;
  transform: scale(1);
  z-index: 1;
}
.navbar .menu li {
  position: absolute;
  top: -20px;
  left: -20px;
  transform-origin: 80px 80px;
  transition: all 0.5s 0.1s;
}
.navbar:hover .menu li {
  transition: all 0.6s;
}
.navbar .menu li a {
  transition: all 0.4s ease 0s;
  width: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 50%;
  position: absolute;
  font-size: 35px;
  color: #fff;
  transition: 0.6s;
  text-decoration: none;
}
.navbar .menu li a:hover {
  color: rgb(9, 240, 240);
}
.clasclicksty {
  color: rgb(9, 240, 240);
}
.navbar .menu li:nth-child(1) {
  transition-delay: 0.02s;
  transform: rotate(375deg);
}
.navbar .menu li:nth-child(1) a {
  transition-delay: 0.04s;
  transform: rotate(345deg);
}
.navbar .menu li:nth-child(2) {
  transition-delay: 0.04s;
  transform: rotate(335deg);
}
.navbar .menu li:nth-child(2) a {
  transition-delay: 0.08s;
  transform: rotate(385deg);
}
.navbar .menu li:nth-child(3) {
  transition-delay: 0.06s;
  transform: rotate(295deg);
}
.navbar .menu li:nth-child(3) a {
  transition-delay: 0.12s;
  transform: rotate(425deg);
}
.navbar .menu li:nth-child(4) {
  transition-delay: 0.18s;
  transform: rotate(615deg);
}

.navbar .menu li:nth-child(4) a {
  transition-delay: 0.18s;
  transform: rotate(825deg);
}
.iconsize {
  font-size: 45px;
}
#send {
  position: fixed;
  bottom: 60px;

  right: 160px;
  z-index: 99;
  width: 30%;
}
.event-count {
  position: absolute;
  top: 0;
  right: -59px;
  font-size: 0.6rem;
  background: #c74b43;
  color: #fff;
  display: block;
  padding: 2px 5px;
  border-radius: 50px;
  transform: rotate(33deg);
}

.close:hover {
  transform: rotate(90deg);
  transition: transform 0.2s linear;
}
</style>
<style>
.notifyStyle .el-icon-info {
  color: #909399 !important;
}

/*谷哥滚动条样式*/

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  position: absolute;
}
::-webkit-scrollbar-thumb {
  background-color: #acaba9;
}
::-webkit-scrollbar-track {
  background-color: rgb(255, 255, 255);
}
</style>
<style>
/* 取消input的上下箭头 */
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>